import { hmr, cl } from '@/js/utils';
import { barbaInit } from '@/js/barba';
import { globalInit } from '@/js/global';
import register from '@/js/components';
import htmx from 'htmx.org';

hmr();

declare global {
  interface Window {
    isDevMode: boolean;
    htmx: typeof htmx;
  }
}

window.htmx = htmx;

(function (doc) {
  register();
  barbaInit();
  globalInit();

  // import('@/js/htmx').catch(() => new Error('htmx not found'));

  if (!window.isDevMode) {
    import('@/js/utils/sentry').then(({ default: SentryInit }) => {
      SentryInit({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        maxBreadcrumbs: 50,
      });
    });
  }

  doc.addEventListener('DOMContentLoaded', () => {
    cl(document.documentElement).remove('to-load');
  });
})(document);
